import { useMemo } from "react";
import { type ScopeAccountSplit, splitScopeByAccountType } from "@/lib/vendor-metric-availability";
import { useAuthStore } from "@/stores/auth";

/**
 * Seller / vendor split of an analytics scope (#679), from the signed-in user's
 * shop list. Drives which SP-API backed displays show a "Vendor Central pending"
 * empty state (all vendors) or a coverage note (mixed).
 */
export function useScopeAccountSplit(
  shopIds: readonly string[] | null | undefined,
): ScopeAccountSplit {
  const shops = useAuthStore((state) => state.shops);
  return useMemo(() => splitScopeByAccountType(shops, shopIds ?? []), [shops, shopIds]);
}
